import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { createStyles, makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  })
);

export default function SimpleBackdrop(props) {
  const classes = useStyles();
  React.useState(false);

  return (
    <div>
      <Backdrop
        style={{ zIndex: "999999" }}
        className={classes.backdrop}
        open={props.open}
        onClick={props.handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
